import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection,addDoc, getDocs, doc, updateDoc, deleteDoc,  Timestamp } from "firebase/firestore";
import "../styles/AdminTurnos.css";

const AdminTurnos = () => {
  const [turnos, setTurnos] = useState([]);
  const [diaSeleccionado, setDiaSeleccionado] = useState("");
  const [estadoFiltro, setEstadoFiltro] = useState("todos"); // nuevo filtro
const [nuevoTurno, setNuevoTurno] = useState({
  nombre: "",
  apellido: "",
  telefono: "",
  fecha: "",
  hora: "",
  servicio: "",
  duracion: "",
  precio: "",
});

  const cargarTurnos = async () => {
    const snap = await getDocs(collection(db, "turnos"));
    let data = snap.docs.map((docu) => ({
      id: docu.id,
      ...docu.data(),
    }));

    // ➤ Filtrar turnos pasados
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    data = data.filter((t) => {
      const fecha = new Date(t.fecha);
      return fecha >= hoy;
    });

    // ➤ Ordenar por fecha y hora
    data.sort((a, b) => {
      const fechaA = new Date(a.fecha);
      const fechaB = new Date(b.fecha);

      if (fechaA.getTime() !== fechaB.getTime()) return fechaA - fechaB;

      return a.hora.localeCompare(b.hora);
    });

    setTurnos(data);
  };

  useEffect(() => {
    cargarTurnos();
  }, []);

  const diasUnicos = [...new Set(turnos.map((t) => t.fecha))];

  // ➤ Filtrar por día y por estado
  const turnosFiltrados = turnos.filter((t) => {
    const coincideDia = diaSeleccionado ? t.fecha === diaSeleccionado : true;
    const coincideEstado =
      estadoFiltro === "todos" ? true : t.estado === estadoFiltro;

    return coincideDia && coincideEstado;
  });
const agregarTurnoManual = async () => {
  if (
    !nuevoTurno.nombre ||
    !nuevoTurno.telefono ||
    !nuevoTurno.fecha ||
    !nuevoTurno.hora ||
    !nuevoTurno.servicio
  ) {
    alert("Completá todos los campos");
    return;
  }

await addDoc(collection(db, "turnos"), {
  ...nuevoTurno,
  duracion: nuevoTurno.duracion || 1,
  precio: nuevoTurno.precio || null,
  estado: "confirmado",
  origen: "manual",
  timestamp: Timestamp.now()
});


  setNuevoTurno({
    nombre: "",
    apellido: "",
    telefono: "",
    fecha: "",
    hora: "",
    servicio: "",
  });

  cargarTurnos();
};

  const enviarConfirmacion = (turno) => {
    const mensaje = `
✅ *Tu turno fue confirmado*

👤 ${turno.nombre} ${turno.apellido}
📞 ${turno.telefono}
💇‍♀️ *Servicio:* ${turno.servicio}
📅 *Fecha:* ${turno.fecha}
⏰ *Hora:* ${turno.hora}

💸 *Precio total:* $${turno.precio || "?"}
💵 *Seña:* $5000
💰 *Restante:* $${turno.precio ? turno.precio - 5000 : "?"}

🏠 Dirección: Pedernera 1064

✨ ¡Te esperamos en Shanna! 💖
    `;

    window.open(
      `https://wa.me/${turno.telefono}?text=${encodeURIComponent(mensaje)}`,
      "_blank"
    );
  };

  const marcarConfirmado = async (id) => {
    await updateDoc(doc(db, "turnos", id), { estado: "confirmado" });
    cargarTurnos();
  };

  const eliminarTurno = async (id) => {
    if (!window.confirm("¿Eliminar este turno? Esta acción no se puede deshacer.")) return;

    await deleteDoc(doc(db, "turnos", id));
    cargarTurnos();
  };

  return (
    
    <div className="admin-container">
      <h2 className="admin-title">Administrador de Turnos 📋</h2>
<div className="admin-agregar-turno agenda-hoja">

  <h3>➕ Agregar turno manual</h3>

  <input
    placeholder="Nombre"
    value={nuevoTurno.nombre}
    onChange={(e) =>
      setNuevoTurno({ ...nuevoTurno, nombre: e.target.value })
    }
  />

  <input
    placeholder="Apellido"
    value={nuevoTurno.apellido}
    onChange={(e) =>
      setNuevoTurno({ ...nuevoTurno, apellido: e.target.value })
    }
  />

  <input
  type="tel"
  placeholder="Teléfono"
  value={nuevoTurno.telefono}
  onChange={(e) =>
    setNuevoTurno({ ...nuevoTurno, telefono: e.target.value })
  }
/>


  <input
    type="date"
    value={nuevoTurno.fecha}
    onChange={(e) =>
      setNuevoTurno({ ...nuevoTurno, fecha: e.target.value })
    }
  />

  <input
    type="time"
    value={nuevoTurno.hora}
    onChange={(e) =>
      setNuevoTurno({ ...nuevoTurno, hora: e.target.value })
    }
  />

  <input
    placeholder="Servicio"
    value={nuevoTurno.servicio}
    onChange={(e) =>
      setNuevoTurno({ ...nuevoTurno, servicio: e.target.value })
    }
  />
<input
  type="number"
  min="1"
  placeholder="Duración (horas)"
  value={nuevoTurno.duracion}
  onChange={(e) =>
    setNuevoTurno({ ...nuevoTurno, duracion: Number(e.target.value) })
  }
/>
  
<input
  type="number"
  placeholder="Precio ($)"
  value={nuevoTurno.precio}
  onChange={(e) =>
    setNuevoTurno({ ...nuevoTurno, precio: e.target.value })
  }
/>

  <button type="button" onClick={agregarTurnoManual}>
  Guardar turno
</button>

</div>

      {/* FILTROS SUPERIORES */}
      <div className="filtros-superiores">
        <div className="filtro-item">
          <label>Filtrar por día:</label>
          <select value={diaSeleccionado} onChange={(e) => setDiaSeleccionado(e.target.value)}>
            <option value="">Todos los días</option>
            {diasUnicos.map((d, i) => (
              <option key={i} value={d}>{d}</option>
            ))}
          </select>
        </div>

        <div className="filtro-item">
          <label>Estado:</label>
          <select value={estadoFiltro} onChange={(e) => setEstadoFiltro(e.target.value)}>
            <option value="todos">Todos</option>
            <option value="pendiente">Pendientes</option>
            <option value="confirmado">Confirmados</option>
          </select>
        </div>
      </div>

      {/* AGRUPADOS POR DÍA */}
      {diasUnicos
        .filter((d) => !diaSeleccionado || d === diaSeleccionado)
        .map((dia, idx) => (
          <div key={idx} className="dia-bloque">
            <h3 className="titulo-dia">📅 {dia}</h3>

            <div className="turnos-grid">
              {turnosFiltrados
                .filter((t) => t.fecha === dia)
                .map((t) => (
                  <div
                    key={t.id}
                    className={`turno-card ${
                      t.estado === "confirmado" ? "turno-confirmado" : "turno-pendiente"
                    }`}
                  >
                    <div className="turno-header">
                      <h3>{t.hora}</h3>
                      <span className={`estado ${t.estado}`}>{t.estado}</span>
                    </div>

                    <p><strong>{t.nombre} {t.apellido}</strong></p>
                    <p>📞 {t.telefono}</p>
                    <p>💇‍♀️ {t.servicio}</p>

                    {t.precio && (
                      <>
                        <p>💰 Precio: <strong>${t.precio}</strong></p>
                        <p>💵 Restante: <strong>${t.precio - 5000}</strong></p>
                      </>
                    )}

                    <div className="turno-acciones">
                      <button onClick={() => enviarConfirmacion(t)} className="btn-whatsapp">
                        Enviar confirmación 💬
                      </button>

                      {t.estado !== "confirmado" && (
                        <button
                          onClick={() => marcarConfirmado(t.id)}
                          className="btn-confirmar"
                        >
                          Confirmar ✔
                        </button>
                      )}

                      <button
                        onClick={() => eliminarTurno(t.id)}
                        className="btn-eliminar"
                      >
                        Eliminar ❌
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default AdminTurnos;
